const { USER_ROLE_GROUPS_IDS, USER_ROLE_IDS } = require('./constants');

exports.canAccessAdmin = ({ currentUser, role }) => {

    if (!currentUser || !role || role.roleGroupId === undefined || role.roleGroupId === null) {
        return false;
    }

    return role.roleGroupId !== USER_ROLE_GROUPS_IDS.STUDENT
        && !USER_ROLE_IDS.STUDENT.includes(currentUser.roleId);
};
